import React from 'react';
import { Link } from 'react-router-dom';
import { LandingLayout } from '../components/landing/Layout';
import { MarketingFixedNav } from '../components/landing/MarketingFixedNav';

interface Props {
  title: string;
  body: string;
}

export const MarketingPlaceholderPage: React.FC<Props> = ({ title, body }) => (
  <LandingLayout hideHeader>
    <MarketingFixedNav />
    <div className="pt-[calc(5.5rem+env(safe-area-inset-top,0px))] sm:pt-[calc(6.5rem+env(safe-area-inset-top,0px))]">
      <section className="mx-auto max-w-2xl px-4 py-16 sm:py-24 text-center">
        <h1 className="text-3xl font-bold text-[#0B1F4A] mb-4">{title}</h1>
        <p className="text-gray-600 leading-relaxed mb-8">{body}</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex justify-center rounded-lg bg-[#1A56DB] px-5 py-2.5 text-sm font-semibold text-white hover:opacity-95"
          >
            Volver al inicio
          </Link>
          <Link
            to="/soporte"
            className="inline-flex justify-center rounded-lg border border-gray-300 px-5 py-2.5 text-sm font-semibold text-[#0B1F4A] hover:bg-gray-50"
          >
            Contacto
          </Link>
        </div>
      </section>
    </div>
  </LandingLayout>
);
